import type { PrimePitchDismissNavigation } from './types';

export const getPrimeDismissPath = (
  goalSlug?: string | null,
  goalUID?: string | null
) => (goalSlug && goalUID ? `/goal/${goalSlug}/${goalUID}/prime` : null);

export type ResolvedDismissNavigation = 'stay' | 'back' | string | null;

export const resolveDismissNavigation = ({
  dismissNavigateTo,
  goalSlug,
  goalUID,
  fallbackGoalSlug,
  fallbackGoalUID
}: {
  dismissNavigateTo?: PrimePitchDismissNavigation;
  goalSlug?: string | null;
  goalUID?: string | null;
  fallbackGoalSlug?: string | null;
  fallbackGoalUID?: string | null;
}): ResolvedDismissNavigation => {
  if (dismissNavigateTo === null) {
    return 'stay';
  }

  if (dismissNavigateTo === 'back') {
    return 'back';
  }

  if (typeof dismissNavigateTo === 'string') {
    return dismissNavigateTo;
  }

  return (
    getPrimeDismissPath(goalSlug, goalUID) ||
    getPrimeDismissPath(fallbackGoalSlug, fallbackGoalUID)
  );
};
